namespace TabAurous.StockPostingHelper {

    export function PostTransaction(_Entity: any) {
        var entity = _Entity;
        var entitykeys = Object.keys(entity);
        var itemdetails = entity.ItemDetails;
        var transactionkeys = Object.keys(new CommonTrans());
        var itemkeys = Object.keys(new CommonStock());
        var bomkeys = Object.keys(new CommonBOM());
         

        var newentity = new CommonTrans();
        var ItemDetails = [];
        for (var t = 0; t < transactionkeys.length; t++) {
            if (transactionkeys[t] in entity) {
                var value = entity[transactionkeys[t]];
                if (transactionkeys[t] == "ItemDetails") {
                    for (var d = 0; d < value.length; d++) {
                        var item = value[d];
                        var newitem = new CommonStock();
                        for (var i = 0; i < itemkeys.length; i++) {
                            var _bomdetails = [];
                            if (itemkeys[i] in item) {
                                if (itemkeys[i] == "BOMDetails") {
                                    var bomdetails = item[itemkeys[i]];
                                    for (var b = 0; b < bomdetails.length; b++) {
                                        var bom = bomdetails[b];
                                        var newbom = new CommonBOM();
                                        for (var m = 0; m < bomkeys.length; m++) {
                                            if (bomkeys[m] in bom) {
                                                 
                                                newbom[bomkeys[m]] = bom[bomkeys[m]];
                                            }
                                        }
                                        _bomdetails.push(newbom);

                                    }
                                }
                                else
                                    newitem[itemkeys[i]] = item[itemkeys[i]];
                            }
                        }
                        newitem.BOMDetails = _bomdetails; 
                        newentity.ItemDetails.push(newitem);

                    }
                } else
                    newentity[transactionkeys[t]] = value;

            }
        }
        //newentity.ItemDetails = ItemDetails;
        return newentity;
        //Stock.CommonStockPostingService.CommonStockPosting({ PostingTrans: newentity }, response => { }, { async: false });
    }

    export class CommonTrans {

        TransId?: number = 0;
        PartyId?: number = 0;
        POSCustomerId?: number = 0;
        TransItemId?: number = 0;
        VoucherNo?: string = '';
        TransDate?: string = '';
        VoucherDate?: string = '';
        VoucherTypeId?: number = 0;
        CompanyId?: number = 0;
        FinancialYearId?: number = 0;
        AutoPosting?: boolean = false;
        ItemDetails?: any = [];

    }
    export class CommonStock {

        StockId?: number = 0;
        RefTransId?: number = 0;
        RefTransItemId?: number = 0;
        TransId?: number = 0;
        TransItemId?: number = 0;
        VoucherDate?: Date = new Date();
        VoucherTypeId?: number = 0;
        VoucherNo?: string = '';
        CompanyId?: number = 0;
        DepartmentId?: number = 0;
        PartyId?: number = 0;
        Line_No?: number = 0;
        BagNo?: string = '';
        SKU?: string = '';
        Lab?: string = '';
        LotNo?: string = '';
        CertificateNo?: string = '';
        RefNo?: string = '';
        ItemTypeId?: number = 0;
        ProductId?: number = 0;
        AttributeId?: number = 0;
        Studded?: number = 0;
        Pieces?: number = 0;
        Weight?: number = 0;
        NetWeight?: number = 0;
        DiamondPieces?: number = 0;
        DiamondWeight?: number = 0;
        StonePieces?: number = 0;
        StoneWeight?: number = 0;
        OtherPieces?: number = 0;
        OtherWeight?: number = 0;
        MetalAmount?: number = 0;
        DiamondAmount?: number = 0;
        StoneAmount?: number = 0;
        OtherAmount?: number = 0;
        CalcOnId?: number = 0;
        UnitRate?: number = 0;
        ImageName?: string = '';
        Hallmark?: number = 0;
        StockAllocation?: number = 0;
        FinancialYearId?: number = 0;
        RefVoucherId?: number = 0;
        POSCustomerId?: number = 0;
        Purity?: number = 0;
        PureWeight?: number = 0;
        SetId?: number = 0;
        ExportPieces?: number = 0;
        MFAmount?: number = 0;
        MF?: number = 0;
        HasB
        BOMDetails?: any = [];
    }
    export class CommonBOM {
        StockBomId?: number = 0;
        StockId?: number = 0;
        Line_No?: number = 0;
        ProductId?: number = 0;
        BOMProductId?: number = 0;

        BOMAttributeId?: number = 0;

        SettingId?: number = 0;
        StoneStatusId?: number = 0;
        CertificateNo?: string = '';
        Lab?: string = '';
        Pieces?: number = 0;
        Weight?: number = 0;
        StdPurity?: number = 0;
        CalcOnId?: number = 0;
        BomRate?: number = 0;
        BomAmount?: number = 0;
        Remarks?: string = '';
        Purity?: number = 0;
        PureWeight?: number = 0;
        IsCustomerItem?: boolean = false;
    }

}